<template>
  <div class="last3SelectionWrapper" v-if="lastThreeSelections.length > 0">
     <div class="last-selections-title">Select from last 3: </div>
     <ul class="last3Selection">
        <li v-for="selection in lastThreeSelections" v-bind:key="selection.id" @click="selectedCountry(selection.id)">
          {{ selection.name }}
        </li>
     </ul>
     
  </div>
  
</template>

<script>
import ItemListService from '../../services/item-list.service';
import EventBus from '../../EventBus';
  export default {
     props: {
       itemListPk:{
          type: Number,
          default: null
       }
     },
     computed: {
       lastThreeSelections(){
          return this.$store.state.itemsList.lastThreeCountrySelections
       }
     },
     methods: {
       async selectedCountry(selectedCountryId){
          try{

      
            const data = {
               key: "shippedFromCountryPk",
               id: this.itemListPk,
               value: selectedCountryId
            }

            console.log(data)

            const setCountry = await ItemListService.setSingleColumn(data)
            EventBus.$emit('items-list.country-set', setCountry.data.theItemInList)

          }catch(errors){
            console.log(errors)
          }
       }
     }
  }
</script>

<style lang="scss" scoped>
  $last-three-option-color: rgb(122, 122, 122);

  .last3SelectionWrapper{
     display: flex;
     margin-top: 10px;
  }
  .last3Selection{
    display: flex;
    flex-direction: row-reverse;
    list-style-type: none;
    flex-wrap: wrap;
    gap: 5px;
    padding-left: 10px;
    margin-bottom: 0;
  }
  .last3Selection li{
    padding: 3px 5px;
    font-size: 11px;
    border:1px solid  $last-three-option-color;
    color:  $last-three-option-color;
    border-radius: 3px;
    cursor: pointer;
    transition: all 300ms ease;
    &:hover{
      transform: scale(0.95) translate(0, 2px);
    }

  }
  .last-selections-title{
    margin-top: 3px;
    font-size: 12px;
    color: rgb(34, 131, 187);
  }

</style>